import { createSlice } from '@reduxjs/toolkit';
import { TdsSurchargeCessState } from './tdsSurchargeCessTypes';
import {createTdsSurchargeCess,fetchTdsSurchargeCessList,fetchTdsSurchargeCessById,updateTdsSurchargeCess,deleteTdsSurchargeCess} from './tdsSurchargeCessActions';

const initialState: TdsSurchargeCessState = {
  surchargeCessList: [],
  selectedRecord: undefined,
  loading: false,
  error: undefined,
};

const tdsSurchargeCessSlice = createSlice({
  name: 'tdsSurchargeCess',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createTdsSurchargeCess.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createTdsSurchargeCess.fulfilled, (state, action) => {
        state.loading = false;
        state.surchargeCessList.push({ ...action.meta.arg, id: action.payload.Id });
      })
      .addCase(createTdsSurchargeCess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All
      .addCase(fetchTdsSurchargeCessList.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTdsSurchargeCessList.fulfilled, (state, action) => {
        state.loading = false;
        state.surchargeCessList = action.payload.data;
      })
      .addCase(fetchTdsSurchargeCessList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch by ID
      .addCase(fetchTdsSurchargeCessById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchTdsSurchargeCessById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedRecord = action.payload;
      })
      .addCase(fetchTdsSurchargeCessById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update
      .addCase(updateTdsSurchargeCess.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateTdsSurchargeCess.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.surchargeCessList.findIndex((item) => item.id === action.meta.arg.id);
        if (index !== -1) {
          state.surchargeCessList[index] = { ...state.surchargeCessList[index], ...action.meta.arg };
        }
      })
      .addCase(updateTdsSurchargeCess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete
      .addCase(deleteTdsSurchargeCess.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteTdsSurchargeCess.fulfilled, (state, action) => {
        state.loading = false;
        state.surchargeCessList = state.surchargeCessList.filter(
          (item) => item.id !== action.meta.arg
        );
      })
      .addCase(deleteTdsSurchargeCess.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default tdsSurchargeCessSlice.reducer;
